<!-- eslint-disable vue/no-v-html -->
<template>
	<Form :validation-schema="valSchema" @submit="butNext">
		<div>
			<div class="container-sm prodMain">
				<div class="row align-items-start">
					<div class="col-3"></div>

					<div class="col-1">&nbsp;</div>

					<div class="col-8">
						<div class="pageTitle">
							<img
								id="iconShoppingCart"
								class="img-fluid"
								src="images\shoppingCartIcon.png"
								onerror="this.onerror=null; this.src='images/placeholder_CompanyLogo.png'"
							/>
							<span class="spanTitle">Customer Detail</span>
						</div>
					</div>
				</div>
			</div>

			<div class="container-sm prodMain">
				<div class="row align-items-start">
					<div class="sectionTitle">Customer Information</div>
				</div>

				<div class="row align-items-start">
					<div class="col-sm-5 formDiv">
						<label for="txtFirstName" class="form-label">
							First Name
						</label>

						<Field
							v-model="customerDetail.FirstName"
							name="FirstName"
							class="form-control"
							placeholder="First Name"
						/>
						<ErrorMessage
							name="FirstName"
							class="alert alert-warning alertVal"
						/>
					</div>
					<div class="col-sm-2 d-none d-sm-block formDiv">&nbsp;</div>
					<div class="col-sm-5 formDiv">
						<label for="txtLastName" class="form-label">
							Last Name
						</label>
						<Field
							v-model="customerDetail.LastName"
							name="LastName"
							class="form-control"
							placeholder="Last Name"
						/>
						<ErrorMessage
							name="LastName"
							class="alert alert-warning alertVal"
						/>
					</div>
				</div>

				<div class="row align-items-start">
					<div class="col-sm-5 formDiv">
						<label for="txtAddress" class="form-label">
							Address
						</label>
						<Field
							id="txtAddress"
							v-model="customerDetail.Address"
							name="Address"
							type="text"
							class="form-control"
							placeholder="Address"
						/>
						<ErrorMessage
							name="Address"
							class="alert alert-warning alertVal"
						/>
					</div>
					<div class="col-sm-2 d-none d-sm-block formDiv">&nbsp;</div>
					<div class="col-sm-5 formDiv">
						<label for="txtAddress2" class="form-label">
							Apt/Suite #
						</label>
						<Field
							id="txtAddress2"
							v-model="customerDetail.AptSuite"
							name="AptSuite"
							type="text"
							class="form-control"
							placeholder="Apt/Suite#"
						/>
						<ErrorMessage
							name="AptSuite"
							class="alert alert-warning alertVal"
						/>
					</div>
				</div>

				<div class="row align-items-start">
					<div class="col-sm-5 formDiv">
						<label for="txtCity" class="form-label">City</label>
						<Field
							id="txtCity"
							v-model="customerDetail.City"
							name="City"
							type="text"
							class="form-control"
							placeholder="City"
						/>
						<ErrorMessage
							name="City"
							class="alert alert-warning alertVal"
						/>
					</div>

					<div class="col-sm-2 d-none d-sm-block formDiv">&nbsp;</div>

					<div class="col-sm-5 formDiv">
						<label for="txtZipPostal" class="form-label">
							Zip/Postal Code
						</label>
						<Field
							id="txtZipPostal"
							v-model="customerDetail.PostalCode"
							name="PostalCode"
							type="text"
							class="form-control"
							placeholder="Zip/Postal Code"
						/>
						<ErrorMessage
							name="PostalCode"
							class="alert alert-warning alertVal"
						/>
					</div>
				</div>

				<div class="row align-items-start">
					<div class="col-sm-5 formDiv">
						<label for="selCountry" class="form-label">
							Country
						</label>

						<Field
							v-model="customerDetail.CountryCode"
							name="Country"
							as="select"
							class="form-select"
							@change="changeCountry($event)"
						>
							<option value="">Select Country</option>
							<option
								v-for="c in countryList"
								:key="c.isoCode"
								:value="c.isoCode"
							>
								{{ c.name }}
							</option>
						</Field>
						<ErrorMessage
							name="Country"
							class="alert alert-warning alertVal"
						/>
					</div>
					<div class="col-sm-2 d-none d-sm-block formDiv">&nbsp;</div>
					<div class="col-sm-5 formDiv">
						<label for="selState" class="form-label">
							State/Province
						</label>

						<Field
							v-model="customerDetail.ProvStateCode"
							name="ProvState"
							as="select"
							class="form-select"
							@change="changeProvState($event)"
						>
							<option value="">Select State/Province</option>
							<option
								v-for="s in stateList"
								:key="s.isoCode"
								:value="s.isoCode"
							>
								{{ s.name }}
							</option>
						</Field>
						<ErrorMessage
							name="ProvState"
							class="alert alert-warning alertVal"
						/>
					</div>
				</div>

				<div class="row align-items-start">
					<div class="col-sm-5 formDiv">
						<label for="txtPhone" class="form-label">Phone</label>
						<Field
							v-model="customerDetail.Phone"
							name="Phone"
							class="form-control"
							placeholder="Phone"
						/>
						<ErrorMessage
							name="Phone"
							class="alert alert-warning alertVal"
						/>
					</div>
					<div class="col-sm-2 d-none d-sm-block formDiv">&nbsp;</div>
					<div class="col-sm-5 formDiv"></div>
				</div>

				<div class="row align-items-start">
					<div class="sectionTitle">Login Information</div>
				</div>

				<div class="row align-items-start">
					<div class="col-sm-5 formDiv">
						<label for="txtPassword" class="form-label">
							Password
							<span>
								Please save this in a safe place, you will need
								it to login.
							</span>
						</label>
						<Field
							v-model="customerDetail.Password"
							name="Password"
							class="form-control"
							placeholder="Password"
							type="password"
						/>
						<ErrorMessage
							name="Password"
							class="alert alert-warning alertVal"
						/>
					</div>
					<div class="col-sm-2 d-none d-sm-block formDiv">&nbsp;</div>
					<div class="col-sm-5 formDiv">
						<label for="txtConfirmPassword" class="form-label">
							Confirm Password
						</label>
						<Field
							v-model="customerDetail.ConfirmPassword"
							name="ConfirmPassword"
							class="form-control"
							placeholder="ConfirmPassword"
							type="password"
						/>
						<ErrorMessage
							name="ConfirmPassword"
							class="alert alert-warning alertVal"
						/>
					</div>
				</div>

				<div class="row align-items-start">
					<div class="col-sm-5 formDiv">
						<label for="txtEmail" class="form-label">
							Email
							<span>This will also be your username.</span>
						</label>
						<Field
							v-model="customerDetail.Email"
							name="Email"
							class="form-control"
							placeholder="Email"
						/>
						<ErrorMessage
							name="Email"
							class="alert alert-warning alertVal"
						/>
					</div>
					<div class="col-sm-2 d-none d-sm-block formDiv">&nbsp;</div>
					<div class="col-sm-5 formDiv">
						<span v-if="checkingEmail" class="emailChecker">
							<img src="images/Spinner-1s-200px.gif" />
							Checking email...
						</span>
					</div>
				</div>
			</div>

			<div v-if="pageMsg" class="container-sm prodMain">
				<div class="row">
					<div class="alert alert-warning" v-html="pageMsg"></div>
				</div>
			</div>

			<div class="container-sm prodMain">
				<div class="row footCommandRow">
					<div class="col-sm-3">
						<a
							href="#"
							class="btn btn-primary butCheckOut"
							@click.prevent="butBack()"
						>
							Back to Cart
						</a>
					</div>

					<div class="col-sm-6 d-none d-sm-block"></div>

					<div class="col-sm-3">
						<!-- <a href="#" class="btn btn-primary butCheckOut"  @click.prevent="butNext()">Payment Details</a> -->
						<button
							type="submit"
							class="btn btn-primary butCheckOut"
						>
							Next
						</button>
					</div>
				</div>
			</div>
		</div>
	</Form>
</template>

<script>
import { Country, State } from "country-state-city";

import {
	// CustomerDetail,
	CustomerDetailsUtils,
} from "@/components/classes/CustomerDetail.js";

import { Field, Form, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import { configure } from "vee-validate";
// import { useIsFormValid } from 'vee-validate';
// import debounce from "lodash/debounce";
import * as Sentry from "@sentry/vue";

let userControllerURL = ""; // "http://localhost:64006/store/api/user/";

configure({
	validateOnBlur: true, // controls if `blur` events should trigger validation with `handleChange` handler
	validateOnChange: false, // controls if `change` events should trigger validation with `handleChange` handler
	validateOnInput: false, // controls if `input` events should trigger validation with `handleChange` handler
	validateOnModelUpdate: false, // controls if `update:modelValue` events should trigger validation with `handleChange` handler
});

// const mockApiRequest = (value) => {
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve(value === "test@example.com");
//     }, 1000);
//   });
// };

// Yup.addMethod(Yup.type, 'mockApiRequest', function(anyArgsYouNeed) {
//     const { message } = anyArgsYouNeed;
//     return this.test('test-name', message, function(value) {
//         const { path, createError } = this;
//         const { some, more, args } = anyArgsYouNeed;
//         // [value] - value of the property being tested
//         // [path]  - property name,
//         // ...
//         return someCondition || conditionTwo || createError(...);
//     });
// });

// async function doesEmailExist(value){

//     if((value!=null) && (value!="")){

//         const data = { email: value };

//         fetch(userControllerURL+"CheckUniqueEmail",{
//             method: 'POST',
//             headers: {
//                 'Accept': 'application/json',
//                 'Content-Type': 'application/json'
//             },
//             body: JSON.stringify(data),
//         })
//         .then(response => {
//             return response.json();
//         }).then(jsonResponse => {
//             console.log(jsonResponse);

//             // if(jsonResponse.emailExists){
//             //     this.pageMsg = "Please choose a different email. The current email address is already in use on our system.";
//             // } else{
//             //     //nav to payment page

//             // }

//             return jsonResponse.emailExists;

//         }).catch (error => {
//                 console.log(error)
//         })

//     } else {
//             return true
//     }

// }

export default {
	name: "CustomerDetails",
	components: {
		Field,
		Form,
		ErrorMessage,
	},
	emits: ["eventname"],
	setup() {
		//   const isValid = useIsFormValid();
	},
	data() {
		const valSchema = yup.object({
			// email: yup.string().required().email(),
			// password: yup.string().required().min(8),
			FirstName: yup.string().required().label("First Name"),
			LastName: yup.string().required().label("Last Name"),
			Address: yup.string().required().label("Address"),
			AptSuite: yup.string().label("Apt/Suite #"), //not required
			City: yup.string().required().label("City"),
			PostalCode: yup.string().required().label("Zip/Postal Code"),
			Country: yup.string().required().label("Country"),
			ProvState: yup.string().required().label("State/Province"),
			Phone: yup.string().required().label("Phone"),

			Password: yup
				.string()
				.required()
				.label("Password")
				.matches(
					/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{10,}$/,
					"Password must contain 1 number, 1 Uppercase letter, 1 Lowercase letter, 1 symbol and be at least 10 characters long."
				),

			ConfirmPassword: yup
				.string()
				.required()
				.label("Confirm Password")
				.oneOf([yup.ref("Password")], "Passwords do not match"),

			Email: yup.string().required().email().label("Email"),
			// .test('checkEmailUnique', 'This email is already registered.',
			// async (email, values) => {

			//     const response = await doEmailCheck(email);
			//         // };

			//     console.log("res:" + response);

			//     return response;

			// // function(value){
			// //     if((value!=null) && (value!="")){
			// //         const data = { email: value };
			// //         fetch(userControllerURL+"CheckUniqueEmail",{
			// //             method: 'POST',
			// //             headers: {
			// //                 'Accept': 'application/json',
			// //                 'Content-Type': 'application/json'
			// //             },
			// //             body: JSON.stringify(data),

			// //         })
			// //         .then(async res => {
			// //             const { isEmailUnique } = await res.json()
			// //             return isEmailUnique
			// //         })
			// //     } else {
			// //                 return true
			// //     }

			// // }

			// }

			// )
		});

		return {
			countryList: [],
			stateList: [],
			customerDetail: {},
			pageMsg: "",
			valSchema,
			checkingEmail: false,
		};
	},

	watch: {
		customerDetail: {
			handler(newCustomerDetail) {
				// if(this.doneInit==true){

				const parsed = JSON.stringify(newCustomerDetail);
				localStorage.setItem("customerDetail", parsed);
				// }
			},

			deep: true,
		},
	},

	//,
	mounted() {
		try {
			userControllerURL = this.apiBaseUrl + "User/";

			let getCountries = Country.getAllCountries();
			let firstItem = "US";
			getCountries.sort((x, y) => {
				return x.isoCode === firstItem
					? -1
					: y.isoCode === firstItem
					? 1
					: 0;
			});
			firstItem = "CA";
			getCountries.sort((x, y) => {
				return x.isoCode === firstItem
					? -1
					: y.isoCode === firstItem
					? 1
					: 0;
			});
			this.countryList = getCountries;

			if (localStorage.getItem("customerDetail")) {
				let custDetUtil = new CustomerDetailsUtils();
				this.customerDetail = custDetUtil.reviveCustomerDetailObj();

				var tempCountryCode = this.customerDetail.CountryCode;
				this.customerDetail.CountryCode = "";
				this.customerDetail.CountryCode = tempCountryCode;

				let getStates = State.getStatesOfCountry(
					this.customerDetail.CountryCode
				);
				this.stateList = getStates;

				var tempProvStateCode = this.customerDetail.ProvStateCode;
				this.customerDetail.ProvStateCode = "";
				this.customerDetail.ProvStateCode = tempProvStateCode;
			}

			// this.customerDetail = new CustomerDetail();

			// this.customerDetail.CountryCode = "";
			// this.customerDetail.ProvStateCode = "";
		} catch (e) {
			console.log(e);
			//add sentry catch error line here
			Sentry.captureException(e);
		}
	},

	methods: {
		butBack() {
			try {
				this.$emit("eventname", "Cart");
			} catch (e) {
				console.log(e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},

		butNext(values) {
			try {
				let ctx = this;
				console.log(this.customerDetail);

				// const parsed = JSON.stringify(this.customerDetail);
				// localStorage.setItem('customerDetail', parsed);

				// localStorage.setItem('customerDetail', JSON.stringify(this.customerDetail));

				const data = { email: values.Email };

				ctx.checkingEmail = true;
				ctx.pageMsg = "";

				fetch(userControllerURL + "CheckUniqueEmail", {
					method: "POST",
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json",
						XApiKey: this.apiKey,
					},
					body: JSON.stringify(data),
				})
					.then((response) => {
						if (response == null) {
							throw new Error(
								"Customer Details - butNext - No response from server"
							);
						}
						return response.json();
					})
					.then((jsonResponse) => {
						console.log(jsonResponse);

						if (jsonResponse.emailExists) {
							ctx.pageMsg =
								"Please choose a different email. The current email address is already in use on our system.";
							ctx.checkingEmail = false;
						} else {
							//nav to terms page
							ctx.$emit("eventname", "Terms");
						}
					})
					.catch((e) => {
						console.log(e);
						Sentry.captureException(e);
					});
			} catch (e) {
				console.log(e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},

		// onSubmit(values) {
		//     alert(JSON.stringify(values, null, 2));
		// },

		// async validateEmail(value) {
		//     const result = await mockApiRequest(value);

		//     return result ? true : "This email is already taken";
		// },

		changeCountry(e) {
			try {
				let getStates = State.getStatesOfCountry(
					this.customerDetail.CountryCode
				);
				this.stateList = getStates;
				this.customerDetail.Country =
					e.target.options[e.target.options.selectedIndex].text;
			} catch (e) {
				console.log(e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},

		changeProvState(e) {
			try {
				// let selProvState = this.stateList.find(
				// 	(el) => el.name == e.target.value
				// );

				this.customerDetail.ProvState =
					e.target.options[e.target.options.selectedIndex].text;
				this.customerDetail.ProvStateCode = e.target.value;
			} catch (e) {
				console.log(e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.formDiv {
	padding-bottom: 30px;
}

.prodMain {
	margin-bottom: 50px;
	max-width: 1000px;
}

.prodMain .pageTitle {
	font-size: 30px;
	margin-bottom: 0px;
}
.brandLogoWrapper {
	text-align: center;
}
#brandLogo {
	margin-bottom: 20px;
	/* min-height:100px; */
	/* width:90px;
    height:90px;
    margin-right:auto;
    margin-left: auto; */
	width: 100%;
	max-width: 90px;
}
#prodImgThumnb {
	margin-bottom: 50px;
	min-height: 100px;
	width: 240px;
	height: 260px;
}
.prodMain .prodTitle {
	font-size: 20px;
	margin-bottom: 30px;
	border-bottom: 1px grey solid;
}

.cartLine {
	font-size: 16px;
}
.cartLine .label {
	font-weight: 400;
}
.cartLine .fee {
	text-align: right;
}
.floatSwitch {
	float: left;
}
.prodMain .label {
	font-weight: 600;
	font-family: Lato Bold, Arial, Helvetica, sans-serif;
}
.prodPlanType {
	margin-bottom: 20px;
	/* border:1px red solid; */
}
.prodPlanType div {
	padding: 0px;
	/* padding-left: 12px; */
	/* border:1px red solid;  */
}
.planTypeLabel {
	margin-left: 10px;
}
.prodDesc {
	margin-bottom: 20px;
}
.prodFee {
	margin-bottom: 20px;
}

.prodCoupon {
	margin-bottom: 20px;
}
.cartLine {
	margin-bottom: 10px;
	border-top: 1px #ddd solid;
	padding-top: 10px;
}
.billAnnual {
	font-size: 12px;
	display: block;
	clear: both;
	color: rgb(90, 89, 89);
}
.feeBlock {
	display: block;
	clear: both;
}
.footCommandRow {
	border-top: 1px #ddd solid;
	margin-top: 40px;
	padding-top: 20px;
	text-align: right !important;
}
a.butRemove {
	font-size: 8px;
	padding: 2px;
}

.form-switch .form-check-input {
	/* width: 2em; */
	margin-left: 0em;
}
.form-check .form-check-input {
	/* float: left; */
	margin-left: 0;
}
/* .planTypeLabel {
   
} */

.btn {
	margin-bottom: 20px;
}

.btn-primary,
.btn-primary:hover {
	background-color: #a9cf3c;
	border-color: #a9cf3c;

	font-weight: 600;
	font-family: Lato Bold, Arial, Helvetica, sans-serif;
}

.butCheckOut,
.butCheckOut:hover {
	width: 100%;
}

.row {
	--bs-gutter-x: 0rem;
}
.iconShoppingCart {
	padding: 0px;
	margin: 0px;
	margin-right: 10px;
}
.spanTitle {
	padding-left: 20px;
}
.colRemoveButton {
	text-align: right;
}
.discountDisc {
	font-size: 12px;
	color: #a9cf3c;
	font-style: italic;
}
.discAmt {
	color: #a9cf3c;
}
.alertVal {
	display: block;
	margin-top: 5px;
	padding: 5px;
	padding-left: 10px;
	padding-right: 10px;
}
.sectionTitle {
	font-size: 20px;
	border-bottom: 1px #ddd solid;
	padding-bottom: 5px;
	margin-bottom: 20px;
	margin-top: 40px;
	color: #a9cf3c;
}
form label span {
	display: block;
	font-size: 12px;
	color: #aaa;
}

.emailChecker {
	height: 40px;
	display: block;
	position: relative;
	padding-left: 35px;
	padding-top: 5px;
}
.emailChecker img {
	width: auto;
	height: 100%;
	left: -10px;
	position: absolute;
	top: 0px;
	float: left;
}
</style>
